import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import {
  Backend,
  BackendModule,
  CollectionActions,
  mergeEntities,
  mergeWebsocketEntities,
  OrderByDirection,
  removeEntityById,
  StoreFeatureState,
  transformObjects,
  updateWebsocketEntities,
} from '..';

function mockTransform(mockObj: any): any {
  return mockObj;
}

export function mockReducer(
  state: StoreFeatureState<'testing'> = {},
  action: CollectionActions<'testing'>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'testing') {
        const { result, ref, order } = action.payload;
        if (result.mockObjects) {
          return mergeEntities<'testing'>(
            state,
            transformObjects(result.mockObjects, mockTransform),
            order,
            ref,
          );
        }
        return state;
      }

      return state;
    }

    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'testing') {
        const { object, ref } = action.payload;
        return mergeWebsocketEntities<'testing'>(
          state,
          transformObjects([object], mockTransform),
          ref,
        );
      }
      return state;
    }

    case 'API_SET_SUCCESS': {
      if (action.payload.type === 'testing') {
        const { object, ref } = action.payload;
        return mergeWebsocketEntities<'testing'>(
          state,
          transformObjects([object], mockTransform),
          ref,
        );
      }
      return state;
    }

    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'testing') {
        const { object: delta, originalObject, ref } = action.payload;
        return updateWebsocketEntities<'testing'>(
          state,
          [originalObject.id],
          mockObj => ({ ...mockObj, ...delta }),
          ref,
        );
      }
      return state;
    }

    case 'API_DELETE_SUCCESS': {
      if (action.payload.type === 'testing') {
        const { originalObject, ref } = action.payload;
        return removeEntityById<'testing'>(ref, state, originalObject.id);
      }
      return state;
    }

    // TODO: Add websocket handling
    case 'WS_MESSAGE': {
      return state;
    }

    default:
      return state;
  }
}

export function mockBackend(): Backend<'testing'> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (_authUid, _ids) => ({
      endpoint: 'mockEndpoint',
    }),
    push: (_authUid, mockObj) => ({
      endpoint: 'mockEndpoint',
      payload: {
        name: mockObj.username,
      },
    }),
    set: (_authUid, mockObj) => ({
      endpoint: 'mockEndpoint',
      payload: {
        name: mockObj.username,
      },
    }),
    update: (_authUid, mockObj) => ({
      endpoint: 'mockEndpoint',
      payload: {
        name: mockObj.username || 'mockName',
      },
      method: 'PUT',
    }),
    remove: (_authUid, id) => ({
      endpoint: 'mockEndpoint',
      payload: {},
      method: 'DELETE',
    }),
  };
}

/**
 * DatastoreTestingModule is the mock collection used in the Datastore integration tests
 */
@NgModule({
  imports: [
    StoreModule.forFeature('testing', mockReducer),
    BackendModule.forFeature('testing', mockBackend),
  ],
})
export class DatastoreTestingModule {}
